import * as React from 'react';

const ChevronRight24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M9.237 6.23a.766.766 0 0 0 0 1.106L14.05 12l-4.813 4.664a.766.766 0 0 0 0 1.107.826.826 0 0 0 1.142 0l5.384-5.218a.765.765 0 0 0 0-1.106L10.38 6.229a.826.826 0 0 0-1.142 0Z"
  }
));
ChevronRight24.Size = 24;
ChevronRight24.Title = "ChevronRight";

export { ChevronRight24 as default };
